import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Achievement } from 'app/shared/services/achievement.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
})
export class SuccessDialogComponent {
  @Input() title: string;
  @Input() achievement: Achievement;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private translateService: TranslateService
  ) {
    if (data && data.achievement) {
      this.achievement = data.achievement;
    }
  }
  
  /**
   * Translates achievement name using the translation service
   * @param achievementName The original achievement name
   * @returns The translated achievement name
   */
  translateAchievementName(achievementName: string): string {
    // If achievement name is missing or empty, return empty string
    if (!achievementName) {
      return '';
    }
    
    const translationKey = `ACHIEVEMENTS.achievementNames.${achievementName}`;
    const translation = this.translateService.instant(translationKey);
    
    // Return original name if translation is not found (returns the key)
    return translation === translationKey ? achievementName : translation;
  }
  
  /**
   * Translates achievement description using the translation service
   * @param achievementName The original achievement name
   * @returns The translated achievement description
   */
  translateAchievementDescription(achievementName: string): string {
    // If achievement name is missing or empty, return empty string
    if (!achievementName) {
      return '';
    }
    
    const translationKey = `ACHIEVEMENTS.achievementDescriptions.${achievementName}`;
    const translation = this.translateService.instant(translationKey);
    
    // If no translation is found, fall back to original description
    if (translation === translationKey) {
      // Find the achievement in our data
      return this.achievement && this.achievement.description ? this.achievement.description : '';
    }
    
    return translation;
  }

  getCurrentAchievementLevel(achievement: Achievement): string {
    const progress = achievement.progress;
    const levels = achievement.levels;
    const levelsArr = ['green', 'bronze', 'silber', 'gold'];

    if (levels) {
      let progressToNextLevel = progress;
      let currentLevel = 'unlocked';

      for (const levelName of levelsArr) {
        const level = levels[levelName];
        if (progressToNextLevel >= level) {
          currentLevel = levelName;
          progressToNextLevel -= level;
        } else {
          break; // Stop checking once the current level is found
        }
      }
      return currentLevel;
    } else if (achievement.finishedAt || (!achievement.hasLevels && achievement.progress === 1)) {
      return 'gold';
    } else {
      return 'unlocked';
    }
  }

  closeAddDialog(): void {
    this.onSelect.emit();
    this.closeDialog();
  }

  closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }

  public navigateAchievementDetails(): void {
    this.closeAddDialog();
    this.router.navigate(['stats']).then();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/success-dialog/success-dialog.component.ts